import React, { FC } from 'react'

const sizes = {
  default: `py-3 px-8`,
  lg: `py-4 px-12`,
  xl: `py-5 px-16 text-lg`
}

const colorsSecondary = {
  red: 'text-primary-default border-primary-default',
  blue: 'text-brandBlue-darker border-brandBlue-darker',
  yellow: 'text-brandYellow-darker border-brandYellow-darker',
  green: 'text-brandGreen-darker border-brandGreen-darker'
}

const colorsPrimary = {
  red: 'from-primary-lighter to-primary-darker hover:bg-primary-darker',
  blue: 'from-brandBlue-lighter to-brandBlue-darker hover:bg-brandBlue-darker',
  yellow: 'from-brandYellow-lighter to-brandYellow-darker hover:bg-brandYellow-darker',
  green: 'from-brandGreen-lighter to-brandGreen-darker hover:bg-brandGreen-darker'
}



type ButtonProps = {
  className?: string
  size: 'default' | 'lg' | 'xl'
  secondary?: boolean
  color?: 'red' | 'blue' | 'yellow' | 'green'
}
const Button: FC<ButtonProps> = ({ children, className = '', size, secondary = false, color = 'red' }) => {
  const colors = secondary
  ? `from-white to-gray-100 hover:gray-100 border-2 ${colorsSecondary[color]}`
  : `${colorsPrimary[color]} text-white`
  return (
    <button
      type="button"
      className={`
        bg-gradient-to-br ${colors}
        rounded-full
        font-semibold
        font-body
        ${sizes[size] || sizes.default}
        ${className}

    `}
    >
      {children}
    </button>
  )
}

export default Button
